// Providers/SocketProvider.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initializeSocket } from "../services/socketService";
import {
  addNotification,
  updateUnClickedNumberNotification,
} from "../features/notifications/notificationSlice";
import { numberUnClickedNotification } from "../services/notificationService";

const SocketContext = createContext(null);

export const SocketProvider = ({ token, children }) => {
  const dispatch = useDispatch();
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (!token) return;

    const newSocket = initializeSocket(token);
    setSocket(newSocket);

    const handleConnect = () => {
      setIsConnected(true);
      console.log("Context knows socket connected");
    };

    const handleDisconnect = () => {
      setIsConnected(false);
    };

    // Setup connection status listeners
    newSocket.on("connect", handleConnect);
    newSocket.on("disconnect", handleDisconnect);

    // Setup application listeners
    newSocket.on("notification_socket", (message) => {
      dispatch(addNotification(message));
      // dispatch(updateUnClickedNumberNotification((prev) => prev + 1));
    });

    newSocket.on("notification_unReadCount", (message) => {
      dispatch(updateUnClickedNumberNotification(message.notificationsCount));
    });

    // Connect the socket
    newSocket.connect();

    // Initial data fetch
    numberUnClickedNotification(token)
      .then(({ data }) => dispatch(updateUnClickedNumberNotification(data)))
      .catch(console.error);

    return () => {
      newSocket.off("connect", handleConnect);
      newSocket.off("disconnect", handleDisconnect);
      newSocket.off("notification_socket");
      newSocket.off("notification_unReadCount");
      newSocket.disconnect();
      setSocket(null);
      setIsConnected(false);
    };
  }, [token, dispatch]);

  return (
    <SocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
